import React from 'react';

import { useLanguage } from 'utils/useLanguage';
import { ISelectItem, PortalDirection } from 'models/commonModel';
import InlineSpinner from 'components/ui/spinner/InlineSpinner';
import FormLabel from '../label/FormLabel';

import styles from './styles.module.scss';

type SizeType = 'sm' | 'lg';

interface Props {
  label?: string;
  labelDesc?: string;
  defaultOptionLabel?: string;
  defaultOptionValue?: string | number | null;
  inputProps?: any;
  defaultValue?: string | number;
  isError?: boolean;
  errorMessage?: string;
  disabled?: boolean;
  itemsList?: ISelectItem<string | number>[];
  isLoading?: boolean;
  required?: boolean;
  customClassName?: string;
  customSelectClassName?: string;
  isLabelInline?: boolean
  dir?: PortalDirection,
  hint?: string;
  hintId?: string;
  size?: SizeType;
  customOptions?: React.ReactNode[]
  onChange?: React.Dispatch<React.SetStateAction<any>>;
  placeholderOption?: string;
  placeholderOptionValue?: string | number | null;
}

const SelectField = ({ label, labelDesc, defaultOptionLabel, defaultOptionValue, inputProps, defaultValue, itemsList, isLoading, isError, errorMessage, required, disabled, customClassName, customSelectClassName, isLabelInline, dir, hint, hintId, size, customOptions, onChange, placeholderOption, placeholderOptionValue   }: Props) => {
  const { direction } = useLanguage();

  return (
    <div className={`form-group flex-fill ${customClassName} ${isLabelInline ? 'd-flex align-items-center gap-2' : ''}`}>
      {label && <FormLabel label={label} labelDesc={labelDesc} isRequired={required} hint={hint} hintId={hintId} isLabelInline={isLabelInline} />}
      <div className='position-relative d-flex align-items-center'>
        {isLoading && (
          <div className={styles.spinnerContainer}>
            <InlineSpinner small varient='secondary' />
          </div>
        )}
        <div className='input-group'>
          <select {...inputProps} disabled={disabled} defaultValue={defaultValue}
            onChange={(e) => {
              inputProps?.onChange?.(e);
              onChange?.(e.target.value);
            }}
            className={`form-select rounded-12 ${customSelectClassName}
                            ${size === 'sm' ? '' : 'p-3'} 
                            ${isLoading && 'bg-body ps-4'}
                            ${isError ? 'is-invalid' : ''}`}
          >
            {placeholderOption && <option value={placeholderOptionValue ?? -1} disabled hidden>{placeholderOption}</option>}
            {defaultOptionLabel && <option value={defaultOptionValue ?? -1}>{defaultOptionLabel}</option>}
            {itemsList?.map((option, index) => {
              return <option dir={dir ?? direction} value={option.value} key={option.value} className='px-3 text-start'>
                {option.label?.substring(0, 50) + (option.label?.length > 50 ? '...' : '')}
              </option>
            })}
            {customOptions}
          </select>
          {errorMessage && <div className='invalid-feedback'>
            {errorMessage}
          </div>}
        </div>
      </div>
    </div>
  );
};

export default SelectField;
